// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class QpsignatureField {
    static getAttributeTypeMap() {
        return QpsignatureField.attributeTypeMap;
    }
}
QpsignatureField.discriminator = undefined;
QpsignatureField.additionalProperties = false;
QpsignatureField.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=qpsignatureField.js.map